import { useNavigate } from "react-router-dom";
import { INVENTORY_STATUS } from "../../constants/constant";

const InventoryNavigation = ({ isWarehouse }) => {
  const navigate = useNavigate();

  return (
    <div className="w-full justify-between border-2 mt-3 text-sm text-[14px] grid text-center grid-cols-5 divide-x divide-gray-300 divide-2 !rounded-lg">
      {INVENTORY_STATUS.map((item, i) => (
        <button
          onClick={() =>
            navigate(
              `${isWarehouse ? "/central-warehouse" : ""}/inventory/${
                item.status
              }`
            )
          }
          className={`hover:bg-gray-100 whitespace-nowrap truncate ${
            window.location.pathname.includes(`/inventory/${item.status}`)
              ? "py-2 bg-blue-500 text-white"
              : "py-2"
          } ${
            i === 0
              ? "rounded-l-lg"
              : i === INVENTORY_STATUS.length - 1
              ? "rounded-r-lg"
              : ""
          }`}
        >
          {item.name}
        </button>
      ))}
    </div>
  );
};

export default InventoryNavigation;
